import { Button, Icon, Tooltip } from '@servicetitan/anvil2';
import InfoIcon from '@servicetitan/anvil2/assets/icons/st/gnav_help_active.svg';
import styles from '../TaskVoiceActions.module.css';
import { getTestIdProps } from '@lib/testUtils';
import { inboxLocators } from '@locators/inbox';
import { taskStrings } from '@components/Task';

type TaskInboundActionsRowProps = {
  /**
   * Indicates the entire control is disabled
   */
  disabled?: boolean;
  /**
   * Indicates the accept button is disabled
   */
  acceptDisabled?: boolean;
  acceptText?: string;
  rejectText?: string;
  acceptTooltip?: string;
  handleAccept?: (e: React.MouseEvent) => void;
  handleReject?: (e: React.MouseEvent) => void;
};

export const TaskInboundActionsRow = ({
  disabled = false,
  acceptDisabled = false,
  acceptText = taskStrings.acceptCall,
  acceptTooltip,
  rejectText = taskStrings.reject,
  handleAccept,
  handleReject,
}: TaskInboundActionsRowProps) => {
  return (
    <div className={styles.buttonsContainer}>
      <Button
        size='small'
        appearance='primary'
        onClick={handleAccept}
        disabled={disabled || acceptDisabled}
        {...getTestIdProps(inboxLocators.taskList.acceptButton)}
      >
        {acceptText}
      </Button>
      <Button
        size='small'
        onClick={handleReject}
        appearance='danger-secondary'
        disabled={disabled}
        {...getTestIdProps(inboxLocators.taskList.rejectButton)}
      >
        {rejectText}
      </Button>
      {acceptTooltip && (
        <Tooltip>
          <Tooltip.Content>{acceptTooltip}</Tooltip.Content>
          <Tooltip.Trigger>
            <Icon svg={InfoIcon} size='medium' />
          </Tooltip.Trigger>
        </Tooltip>
      )}
    </div>
  );
};
